import { AxiosInstance } from "axios";
import { TGetWhiteLabelConfigParams } from "../@types/Params/TWhiteLabelConfigParams";
import { TGetWhiteLabelGroupParams } from "../@types/Params/TWhiteLabelGroupParams";
import { TGetWhiteLabelConfigResult } from "../@types/Result/TWhiteLabelConfigResult";
import { TGetWhiteLabelGroupResult } from "../@types/Result/TWhiteLabelGroupResult";
import { ICampaignService } from "../interfaces/ICampaignService";

class CampaignService implements ICampaignService {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getWhiteLabelConfigs(
    params: TGetWhiteLabelConfigParams
  ): Promise<TGetWhiteLabelConfigResult> {
    const path = `/white-label-config/${params.campaignId}`;
    const result = await this.client.get<TGetWhiteLabelConfigResult>(path);
    return result.data;
  }

  async getWhiteLabelGroup(
    params: TGetWhiteLabelGroupParams
  ): Promise<TGetWhiteLabelGroupResult> {
    const path = `/white-label-group/${params.groupId}`;
    const result = await this.client.get<TGetWhiteLabelGroupResult>(path);
    return result.data;
  }
}

export { CampaignService };
